export default __webpack_public_path__ + "static/media/logout_black.9020c188.svg";